import DynamicCardFeed from '../scripts/sections/DynamicCardFeed';
import DynamicContentSlider from '../scripts/sections/DynamicContentSlider';
import DynamicFeaturedProduct from '../scripts/sections/DynamicFeaturedProduct';
import DynamicStickyMediaWSteps from '../scripts/sections/DynamicStickyMediaWSteps';
import DynamicProductFeed from '../scripts/sections/DynamicProductFeed';
import DynamicTestimonials from '../scripts/sections/DynamicTestimonials';
import DynamicVideoCarousel from '../scripts/sections/DynamicVideoCarousel';

// Sections
import MainBlog from '../scripts/sections/MainBlog';
import AnnouncementBar from '../scripts/sections/AnnouncementBar';
import MainCart from '../scripts/sections/MainCart';
import MainCollection from '../scripts/sections/MainCollection';
import MainCollectionBanner from '../scripts/sections/MainCollectionBanner';
import MainFaq from '../scripts/sections/MainFaq';
import MainHeader from '../scripts/sections/MainHeader';
import MainMinicart from '../scripts/sections/MainMinicart';
import MainProduct from '../scripts/sections/MainProduct';
import Sections from '../scripts/helpers/SectionManager';

import initAOS from '../scripts/global/initAos';
import initChat from '../scripts/global/initChat';
import initModals from '../scripts/global/initModals';
import initVideos from '../scripts/global/initVideos';

// Init global sections
const sections = new Sections();
sections.register('main-product', section => new MainProduct(section));
sections.register(
  'main-collection-grid',
  section => new MainCollection(section),
);
sections.register(
  'main-collection-banner',
  section => new MainCollectionBanner(section),
);
sections.register('main-blog', section => new MainBlog(section));
sections.register('main-faq', section => new MainFaq(section));
sections.register('main-header', section => new MainHeader(section));
sections.register('main-minicart', section => new MainMinicart(section));
sections.register('main-cart', section => new MainCart(section));
sections.register('main-search', section => new MainCollection(section));
sections.register('announcement-bar', section => new AnnouncementBar(section));

sections.register(
  'dynamic-testimonials',
  section => new DynamicTestimonials(section),
  { lazy: true },
);
sections.register(
  'dynamic-card-feed',
  section => new DynamicCardFeed(section),
  { lazy: true },
);
sections.register(
  'dynamic-product-feed',
  section => new DynamicProductFeed(section),
  { lazy: true },
);
sections.register(
  'dynamic-featured-product',
  section => new DynamicFeaturedProduct(section),
  {
    lazy: true,
  },
);
sections.register(
  'dynamic-content-slider',
  section => new DynamicContentSlider(section),
  { lazy: true },
);
// DynamicContentSlider is a generic responsive Splide driver, not specific to
// the content slider. dynamic-article-feed and dynamic-flexible-cards reuse it
// for their mobile-carousel / desktop-grid layouts, so it has three callers —
// keep its data contract stable.
sections.register(
  'dynamic-article-feed',
  section => new DynamicContentSlider(section),
  { lazy: true },
);
sections.register(
  'dynamic-flexible-cards',
  section => new DynamicContentSlider(section),
  { lazy: true },
);
sections.register(
  'dynamic-sticky-media-w-steps',
  section => new DynamicStickyMediaWSteps(section),
  { lazy: true },
);
sections.register(
  'dynamic-sticky-media-w-steps-metaobject',
  section => new DynamicStickyMediaWSteps(section),
  { lazy: true },
);
sections.register(
  'dynamic-video-carousel',
  section => new DynamicVideoCarousel(section),
  { lazy: true },
);

initAOS();
initVideos();
initModals();
initChat();
